import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Icon, Row, Col, Button, Divider, Dropdown, Menu, Calendar, Select } from 'antd';
import moment from 'moment';
import _ from 'underscore';
import './style.css';

import NewHoliday from './childs/new.holiday';
import NewWeeked from './childs/new.weekend';

// Actions
import { get_company, save_holiday, get_holidays, delete_holiday, get_users } from './actions/holiday.action';
const Option = Select.Option;
class Holidays extends Component {

    constructor( props ){
        super( props );

        this.state = {
            holiday_model: false,
            weekend_model: false,
            company_data: [],
            holiday_dates: [],
            company_id: '',
            users: []
        }

        this.handleCalnder          = this.handleCalnder.bind( this );
        this.handleNewWeekend       = this.handleNewWeekend.bind( this );
        this.handleNewHoliday       = this.handleNewHoliday.bind( this );
        this.handleSubmitWeekend    = this.handleSubmitWeekend.bind( this );
        this.dateCellRender         = this.dateCellRender.bind( this );
        this.getListData            = this.getListData.bind( this );
        this.handleSubmitHoliday    = this.handleSubmitHoliday.bind( this );
        this.is_weekend             = this.is_weekend.bind( this );
        this.handleCompany          = this.handleCompany.bind( this );
        this.handleDateSelection    = this.handleDateSelection.bind( this );
        this.handlePanelChange      = this.handlePanelChange.bind( this );

    }

    handlePanelChange( data){

        let current_year = moment( data ).format( 'YYYY' );
        this.props.get_holidays( this.state.company_id, current_year );
        this.setState({ current_year: current_year });
    }

    handleSubmitWeekend( data ){
        // None
    }

    handleDateSelection( e ){
        if( e.key === '1' ){
            if( e.item.props.id !== 0 ){
                this.props.delete_holiday( e.item.props.id );
            }
        }
    }
    
    handleSubmitHoliday( data ){
        this.props.save_holiday( data );
    }

    handleCompany( value ){
        
        this.props.get_holidays( value, this.state.current_year );
        this.setState({ company_id: value, weekend_model : false, holiday_model: false });

    }

    handleNewWeekend(){
        this.setState({ weekend_model : true, holiday_model: false });
    }

    handleNewHoliday(){
        this.setState({ weekend_model : false, holiday_model: true })
    }

    handleCalnder( value, mode ){
        // console.log( value );
        // console.log( mode );
    }

    componentWillMount(){

        let year = new Date().getFullYear();

        this.props.get_company( year );
        this.props.get_users();

        this.setState({
            current_year: year
        })

    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.holiday.length === 0 ){
            console.log( 'Slow Data Fetching ...' )
            return false;
        }

        if( nextProps.holiday.STATUS.CODE === "200" && 
            nextProps.holiday.STATUS.MESSAGE === "Successfully Listed Users" ){
            this.setState({ users: nextProps.holiday.OUTPUT.DATA })
        }

        if( nextProps.holiday.STATUS.CODE === "200" && 
            nextProps.holiday.STATUS.MESSAGE === "Successfully Listed Company" ) {

            this.setState({
                company_data: nextProps.holiday.OUTPUT.DATA,
                company_id: nextProps.holiday.OUTPUT.DATA[0].company_id,
                weekends: nextProps.holiday.OUTPUT.DATA[0].weekends,
                weekend_model : false, holiday_model: false
            });

            this.props.get_holidays( nextProps.holiday.OUTPUT.DATA[0].company_id, this.state.current_year );
            
        } else if( nextProps.holiday.STATUS.CODE === "200" && 
            nextProps.holiday.STATUS.MESSAGE === "Successfully Listed Holiday" ) {

            this.setState({
                holiday_dates: nextProps.holiday.OUTPUT.DATA,
                weekends: nextProps.holiday.OUTPUT.DATA[0].weekends,
                weekend_model : false, holiday_model: false
            });


        } else if( nextProps.holiday.STATUS.CODE === "200" && 
            nextProps.holiday.STATUS.MESSAGE === "Successfully Saved Holidays" ) {
            
            this.setState({ weekend_model : false, holiday_model: false });
            this.props.get_company( this.state.current_year );
            this.props.get_holidays( this.state.company_id, this.state.current_year );

            window.location.reload();

        } else if( nextProps.holiday.STATUS.CODE === "200" && 
            nextProps.holiday.STATUS.MESSAGE === "Successfully Deleted Holiday" ) {
            
            this.setState({ weekend_model : false, holiday_model: false });
            this.props.get_company( this.state.current_year );
            this.props.get_holidays( this.state.company_id, this.state.current_year );

        }

    }

    dateCellRender( value ) {


        const list_dates = this.getListData( value );
        
        return (
            <span>
                {
                    list_dates.map( ( item, i ) => {
                        if( item.name === 'Weekend' ){
                            return <span className="events" id={ item.name } >
                                { item.name }
                            </span>
                        } else {
                            return <Dropdown key={ i } overlay={
                                <Menu onClick={ this.handleDateSelection }>
                                    <Menu.Item key="1" id={ item.id }>
                                        Delete
                                    </Menu.Item>
                                </Menu>
                            } trigger={[ 'click' ]}>
                            <span className="events" id={ item.name } >
                                { item.name }
                            </span></Dropdown>
                        }
                    })
                }
            </span>
        );

    }

    getListData( value ){

        let list_data= [];
        let current_date = moment( value ).format( 'YYYY-MM-DD' );

        _.map( this.state.holiday_dates, ( date, i ) => { 
            if( date.holiday_date === current_date ){
                list_data.push( { id: date.holiday_id, name: date.holiday_name } );
                return false;
            }
        });

        if( this.is_weekend( current_date ) === 'weekend' ){
            list_data.push( { id: 0, name: 'Weekend' } );
        }

        return list_data;
        
    }

    is_weekend( date1 ){

        let dt = new Date(date1),weekend=[],off = '';

        if( this.state.weekends ){
            weekend = this.state.weekends.split(',');
        }
        
        _.map( weekend, ( item, i )=> {
            if( dt.getDay() == parseInt( item ) ){
                off = "weekend";
            } 
        })

        return off;
         
    }

    render() {

        const company_list = this.state.company_data.map( ( item, i ) => <Option key={ item.company_id }>{ item.company_name }</Option> )

        return (
            <div className="holiday_wrapper">
                
                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="form" />
                            &nbsp; Holidays
                        </h2>
                    </Col>
                    <Col span={12}>

                        <Button
                            onClick={ this.handleNewHoliday }
                            className="fl_right" type="primary" icon="plus">Add Holidays</Button>

                        <Select
                            onChange={ this.handleCompany }
                            placeholder="Select Company"
                            value={ this.state.company_id }
                            className="fl_right" style={{ width: '250px', marginRight: '10px' }}>
                            { company_list }
                        </Select>

                    </Col>
                </Row>

                <Divider />

                <Row gutter={16}>
                    <Col span={24}>
                        <Calendar 
                            onPanelChange={ this.handlePanelChange }
                            dateCellRender={ this.dateCellRender } />
                    </Col>
                </Row>

                <NewHoliday onSubmit={ this.handleSubmitHoliday } onModel={ this.state.holiday_model } 
                    user_data={ this.state.users }
                    company_data={ this.state.company_data }/>
                <NewWeeked onSubmit={ this.handleSubmitWeekend } onModel={ this.state.weekend_model } company_data={ this.state.company_data } />

            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        holiday: state.holiday
    }
}

export default connect( mapStatetoProps, { get_company, save_holiday, get_holidays, delete_holiday, get_users })( Holidays );



// WEBPACK FOOTER //
// ./src/pages/holidays/index.js